module.exports = __webpack_public_path__ + "static/mobile-2-e139a7e7d77430bd2fa63461a5a79410.png";